import { render, staticRenderFns } from "./SliderComponent.vue?vue&type=template&id=43190244"
import script from "./SliderComponent.vue?vue&type=script&lang=js"
export * from "./SliderComponent.vue?vue&type=script&lang=js"
import style0 from "./SliderComponent.vue?vue&type=style&index=0&id=43190244&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43190244')) {
      api.createRecord('43190244', component.options)
    } else {
      api.reload('43190244', component.options)
    }
    module.hot.accept("./SliderComponent.vue?vue&type=template&id=43190244", function () {
      api.rerender('43190244', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/slider/SliderComponent.vue"
export default component.exports